import { useState, useEffect } from "react";

import moment from "moment";

// import { useWallProvider } from "../context/WallProvider";

import SiteDetail from "./SiteDetail";
import Comments from "./Comments";
import Files from "./Files";
import Walls from "./Walls";

import { useParams, Link, useHistory } from "react-router-dom";
import { firestore } from "../firebase";
import firebase from "firebase/compat/app";
import { useUserProvider } from "../context/UserProvider";
import { collectIdsAndDocs } from "../utils";

import EditIcon from "@mui/icons-material/Edit";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  Button,
  MenuItem,
  Box,
  Grid,
  Stack,
  Divider,
  Typography,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import { setDoc, collection, doc } from "firebase/firestore";

const tabs = [
  { label: "Details", value: "details" },
  { label: "Comments", value: "comments" },
  { label: "Documents", value: "documents" },
  { label: "Walls", value: "walls" },
];

const HeaderSingleSite = ({
  clientCompany,
  clientEmail,
  clientFirstName,
  clientLastName,
  clientTelephone,
  entrepreneurCompany,
  entrepreneurCompanyNumber,
  entrepreneurEmail,
  entrepreneurFirstName,
  entrepreneurLastName,
  entrepreneurTelephone,
  siteConstructionYear,

  siteNotes,

  sitePostalCode,

  siteHousingType,
  siteMunicipality,
  siteNumber,
  siteStreet,
  createdAt,

  id,
  // user,
}) => {
  const { user } = useUserProvider();
  const [currentTab, setCurrentTab] = useState("details");

  const [site, setSite] = useState("");
  const [comments, setComments] = useState([]);
  const [files, setFiles] = useState([]);
  const [walls, setWalls] = useState([]);
  // const { walls } = useWallProvider();
  // const { id } = useParams();
  // const { user } = useUserProvider();

  const siteRef = firestore.doc(`sites/${id}`);
  const commentsRef = siteRef.collection("comments");
  const filesRef = siteRef.collection("files");
  const wallsRef = siteRef.collection("walls");
  // const wallRef = firestore.doc(`walls/${id}`);

  // docData.forEach((item) => {
  //   siteRef
  //     .collection("walls")
  //     .where("docId", "==", item)
  //     .get()
  //     .then(function (doc) {
  //       doc.forEach(function (docV) {
  //         console.log("Slot data", docV.data());
  //       });
  //     });
  // });

  // await Promise.all([
  //   setDoc(doc(wallsRef,"after works"))
  // ])

  const existingField = [
    clientCompany &&
      clientEmail &&
      clientFirstName &&
      clientLastName &&
      clientTelephone &&
      entrepreneurCompany &&
      entrepreneurCompanyNumber &&
      entrepreneurEmail &&
      entrepreneurFirstName &&
      entrepreneurLastName &&
      entrepreneurTelephone &&
      siteConstructionYear &&
      siteHousingType &&
      siteMunicipality &&
      siteNotes &&
      siteNumber &&
      sitePostalCode &&
      siteStreet,
  ];

  // const addWall = (wall) => {
  //   const { uid, displayName, email, formData } = user;
  //   filesRef.add({
  //     formData,
  //     createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  //     uid,
  //     displayName,
  //     email,
  //   });

  //   wallsRef.update({ walls: site.walls + 1 });
  // };

  const sendFiles = (file) => {
    const { uid, caption, displayName, email } = user;
    filesRef.add({
      images: file,
      caption,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      displayName,
      email,
    });

    siteRef.update({ files: site.files + 1 });
  };

  const createCommment = (comment) => {
    const { uid, displayName, email } = user;
    commentsRef.add({
      content: comment,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      displayName,
      email,
    });

    siteRef.update({ comments: site.comments + 1 });
  };

  // const createWall = (wall) => {
  //   const { uid, displayName, email } = user;
  //   wallsRef.add({
  //     // formData: registrationPeriod,
  //     // registrationPeriod,
  //     createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  //     uid,
  //     displayName,
  //     email,
  //   });

  //   siteRef.update({ walls: site.walls + 1 });
  // };

  let unsubscribeFromSite = null;
  let unsubscribeFromComment = null;
  let unsubscribeFromWall = null;
  let unsubscribeFromFile = null;

  useEffect(() => {
    unsubscribeFromSite = siteRef.onSnapshot((snapshot) => {
      const site = collectIdsAndDocs(snapshot);
      setSite(site);
    });

    unsubscribeFromComment = commentsRef.onSnapshot((snapshot) => {
      const comments = snapshot.docs.map(collectIdsAndDocs);

      setComments(comments);
    });

    unsubscribeFromWall = wallsRef.onSnapshot((snapshot) => {
      const walls = snapshot.docs.map(collectIdsAndDocs);

      setWalls(walls);
    });

    unsubscribeFromFile = filesRef.onSnapshot((snapshot) => {
      const files = snapshot.docs.map(collectIdsAndDocs);

      setFiles(files);
    });

    return () => {
      unsubscribeFromComment();
      unsubscribeFromWall();
      unsubscribeFromSite();
      unsubscribeFromFile();
    };
  }, []);

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };

  const { nanoseconds, seconds } = createdAt !== null && createdAt;
  var timestamp = { nanoseconds, seconds };
  const dateTime = new Date(timestamp?.seconds * 1000);

  // const { user: currentUser } = useUserProvider();
  const location = useHistory().location.pathname;

  const belongsToCurrentUser = (currentUser, siteAuthor) => {
    if (!currentUser) return false;

    return currentUser.uid === siteAuthor.uid;
  };
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  return (
    <Box sx={{ pb: 0 }}>
      <Box
        sx={{
          mt: -2,
          mb: {
            xs: 0,
            sm: 2,
            md: 2,
            lg: 2,
          },
        }}
      >
        <MenuItem
          className="backlink"
          component={Link}
          sx={{
            p: "0",
          }}
          to="/dashboard"
        >
          <Grid container>
            <Grid
              item
              sx={{
                alignItems: "center",
                display: "flex",
                overflow: "hidden",
                pr: ".5em",
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </Grid>
            <Grid
              item
              sx={{
                alignItems: "center",
                display: "flex",
                overflow: "hidden",
              }}
            >
              <Typography variant="subtitle2">Sites</Typography>
            </Grid>
          </Grid>
        </MenuItem>
      </Box>
      <Grid container justifyContent="space-between" spacing={3}>
        <Grid
          item
          sx={{
            alignItems: "center",
            display: "flex",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              mr: 2,
              p: 1,
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" && isSmallScreen
                  ? "#00162b"
                  : theme.palette.mode === "light" && isSmallScreen
                  ? "#8eb5d2"
                  : "#3399ff",
              borderRadius: 2,
              maxWidth: "fit-content",
            }}
          >
            <Typography
              align="center"
              color={(theme) =>
                theme.palette.mode === "dark" && isSmallScreen
                  ? "#8eadcc"
                  : "#fff"
              }
              variant="subtitle2"
            >
              {moment(dateTime).format("MMM").toUpperCase()}
            </Typography>
            <Typography
              align="center"
              color={(theme) =>
                theme.palette.mode === "dark" && isSmallScreen
                  ? "#8eadcc"
                  : "#fff"
              }
              variant="h6"
            >
              {moment(dateTime).format("DD").toUpperCase()}
            </Typography>
          </Box>
          <div>
            <Typography variant={isSmallScreen ? "h5" : "h4"}>
              {siteStreet}, {siteNumber}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {existingField != undefined && existingField != "" ? (
                <CheckCircleIcon fontSize="small" color="primary" />
              ) : (
                <TimelapseIcon fontSize="small" sx={{ color: "#8D9EB7" }} />
              )}
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                Site
              </Typography>
              <Typography
                // color="textSecondary"
                variant="subtitle2"
                sx={{
                  ml: 1,
                  color: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgb(128, 191, 255)"
                      : "#1b78d5",
                }}
              >
                {siteHousingType}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {siteMunicipality}
              </Typography>
            </Box>
          </div>
        </Grid>
        <Grid item>
          <Stack direction="row" spacing={2}>
            {!user ? (
              <Link to="/login" style={{ textDecoration: "none" }}>
                <Button
                  component="a"
                  // endIcon={<EditIcon fontSize="small" />}
                  sx={{ m: 1 }}
                  variant="outlined"
                  size="small"
                >
                  Sign in to add a new site
                </Button>
              </Link>
            ) : (
              <>
                <Link to={`/editSite/${id}`} style={{ textDecoration: "none" }}>
                  <Button
                    component="a"
                    endIcon={<EditIcon fontSize="small" />}
                    sx={{ mr: 1, mt: 1 }}
                    variant="outlined"
                    className="outlined_2"
                    size="small"
                  >
                    Edit site
                  </Button>
                </Link>
                <Link
                  to={`/addnewwall/${id}`}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    className="contained_2"
                    component="a"
                    endIcon={<AddIcon fontSize="small" />}
                    sx={{ mt: 1 }}
                    variant="contained"
                    size="small"
                  >
                    ADD NEW WALL
                  </Button>
                </Link>
              </>
            )}
          </Stack>
        </Grid>
      </Grid>
      <Tabs
        indicatorColor="primary"
        onChange={handleTabsChange}
        scrollButtons="auto"
        textColor="primary"
        value={currentTab}
        variant="scrollable"
        sx={{ mt: 3 }}
      >
        {tabs.map((tab) => (
          <Tab
            sx={{ color: "textSecondary" }}
            key={tab.value}
            label={tab.label}
            value={tab.value}
            component={Link}
            to={`/sites/${id}/${tab.value}`}
            // containerElement={<Link to={`/sites/${id}/${tab.value}`} />}
          />
        ))}
      </Tabs>
      <Divider sx={{ mb: 3 }} />
      {currentTab === "details" && site && <SiteDetail {...site} />}
      {currentTab === "comments" && (
        <Comments comments={comments} onCreate={createCommment} />
      )}
      {currentTab === "documents" && (
        <Files files={files} onCreate={sendFiles} siteRef={siteRef} />
      )}
      {currentTab === "walls" && (
        <Walls
          walls={walls}
          siteRef={siteRef}
          siteStreet={siteStreet}
          siteNumber={siteNumber}
          {...walls}
        />
      )}
    </Box>
  );
};

export default HeaderSingleSite;
